module.exports = __webpack_public_path__ + "img/banner3.c391b3ef.png";